module.exports = __webpack_public_path__ + "img/blended-min.428c905a.jpg";